import {makeStyles} from "@material-ui/core/styles";
import React, {FC} from "react";
import clsx from "clsx";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import {AppBar, IconButton, Toolbar} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import {
    AccountCircleOutlined, ChevronLeft,
    EventOutlined,
    FormatListBulletedOutlined,
    HomeOutlined,
    PowerSettingsNewOutlined
} from "@material-ui/icons";
import {useHistory, useLocation} from "react-router-dom";
import logo_green from "../../../orderEngine/logo_green.png";
import {useLogout} from "../../../auth/redux/auth.hook";

const useStyles = makeStyles(() => ({
    list: {
        width: 250,
    },
    title: {
        display: 'flex',
        alignItems: 'center',
        flexGrow: 1,
    }
}));

export const WorkerAppNavBar: FC = () => {
    const classes = useStyles();
    const history = useHistory();
    const [menuOpen, setMenuOpen] = React.useState(false);

    const location = useLocation();

    const {logout} = useLogout();

    const toggleDrawer = (open: boolean) => (
        event: React.KeyboardEvent | React.MouseEvent,
    ) => {
        if (
            event &&
            event.type === 'keydown' &&
            ((event as React.KeyboardEvent).key === 'Tab' ||
                (event as React.KeyboardEvent).key === 'Shift')
        ) {
            return setMenuOpen(false);
        }
        setMenuOpen(!open);
    };

    return (
        <React.Fragment>
            <AppBar color="inherit" position="sticky">
                <Toolbar style={{position: "relative"}}>
                    <IconButton
                        disabled={location.pathname === "/worker"}
                        edge="start"
                    onClick={() => history.push("/worker")}>
                        <ChevronLeft style={{color: location.pathname === "/worker" ? "transparent" : undefined}}/>
                    </IconButton>
                    <img style={{
                        maxHeight: 80
                    }} alt="logo" src={logo_green}/>
                    <IconButton
                        edge="end"
                        color="inherit"
                        aria-label="menu"
                        style={{position: "absolute", right: 16}}
                        onClick={toggleDrawer(menuOpen)}
                    >
                        <MenuIcon/>
                    </IconButton>
                </Toolbar>
            </AppBar>
            <SwipeableDrawer
                anchor={"right"}
                open={menuOpen}
                onClose={toggleDrawer(menuOpen)}
                onOpen={toggleDrawer(menuOpen)}
            >
                <div
                    className={clsx(classes.list)}
                    role="presentation"
                    onClick={toggleDrawer(menuOpen)}
                    onKeyDown={toggleDrawer(menuOpen)}
                >
                    <List>
                        <ListItem
                            button
                            onClick={() => {
                                history.push('/worker')
                            }}
                        >
                            <ListItemIcon><HomeOutlined/></ListItemIcon>
                            <ListItemText primary={"Home"}/>
                        </ListItem>
                        <Divider/>
                        <ListItem
                            button
                            onClick={() => {
                                history.push('/worker/personal-data')
                            }}
                        >
                            <ListItemIcon><AccountCircleOutlined/></ListItemIcon>
                            <ListItemText primary={"Meine Daten"}/>
                        </ListItem>
                        <Divider/>
                        <ListItem
                            button
                            onClick={() => {
                                history.push('/worker/calendar')
                            }}
                        >
                            <ListItemIcon><EventOutlined/></ListItemIcon>
                            <ListItemText primary={"Meine Verfügbarkeiten"}/>
                        </ListItem>
                        <Divider/>
                        <ListItem
                            button
                            onClick={() => {
                                history.push('/worker/schedule')
                            }}
                        >
                            <ListItemIcon><FormatListBulletedOutlined/></ListItemIcon>
                            <ListItemText primary={"Aufträge"}/>
                        </ListItem>
                        <Divider/>
                        <ListItem
                            button
                            style={{marginTop: "auto"}}
                            onClick={logout}
                        >
                            <ListItemIcon><PowerSettingsNewOutlined/></ListItemIcon>
                            <ListItemText primary={"Ausloggen"}/>
                        </ListItem>
                    </List>
                </div>
            </SwipeableDrawer>
        </React.Fragment>
    );
}
